import React, { FC } from 'react';
import { MarginalItemProps } from './PageWrapper';
import styled from 'styled-components';
import { Breakpoints, Colors, IconDefinitions } from '../..';
import { Icon } from './Icon';
import { NavLink } from 'react-router-dom';
import { useBreakpoint } from '../../styles/breakpoints';

export interface SiteNavigationItemProps {
  item: MarginalItemProps;
}

const ItemWrapper = styled.li`
  :after {
    position: relative;
    height: 1px;
    width: calc(100% - 2.25rem);
    left: 50%;
    background-color: ${Colors.gray};
    display: block;
    content: "";
    transform: translateX(-50%);
    margin: .25rem 0;
    
    ${useBreakpoint('l')} {
      width: calc(100% - 3rem);
      margin: .5rem 0;
    }
   }
   
   :last-child {
     :after {
       display:none;
     }
   }
`;

const StyledActionLink = styled.button` 
    text-align: start;
    width: 100%;
    max-width: 30vw;
    border: none;
    background: transparent;  
    color: ${Colors.grayDark};
    font-size: 1rem;
 `;

const StyledLink = styled(NavLink)`
  display: flex;
  width: 100%;
  text-decoration: none;
  color: ${Colors.grayDark};
  font-size: 1rem;
`;

export const StyledSubNavigationItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: .5rem 0;
  
  ${useBreakpoint('l')} {
    padding: 1rem 0;
  }

   &:hover {
      color: ${Colors.tertiary};
      cursor: pointer;
   }
`;

const IconWrapper = styled.div`
  margin-right: 1rem;
`;

const LinkWrapper = styled.div`
  //padding-bottom: 2rem;
  width: 100%;
  display: flex;
  align-items: center;

   :last-of-type {
     padding-bottom: 0;
   }
`;

export const SiteNavigationItem: FC<SiteNavigationItemProps> = (props) => {
  const { item } = props;

  const content = (
    <StyledSubNavigationItem>
      <IconWrapper>
        <Icon color={'inherit'} size={window.innerWidth < Breakpoints.l ? 16 : 24} icon={item.icon as IconDefinitions} />
      </IconWrapper>
      <LinkWrapper>
        {item.text}
      </LinkWrapper>
    </StyledSubNavigationItem>
  );

  return (
    <ItemWrapper>
    {
      item.actionFn
        ? (
          <StyledActionLink
            onClick={(event: React.FormEvent<HTMLButtonElement>) => {
              event.preventDefault();
              item.actionFn();
            }}
          >
            { content }
          </StyledActionLink>
        )
        : (
          <StyledLink to={item.route}>
            { content }
          </StyledLink>
        )
    }
    </ItemWrapper>
  );
};
